import React, { useState } from "react";
import TextField from "@material-ui/core/TextField";
import _ from 'lodash';

// Need to create outside of function for debounce to work
const onBlur = (onChange, value) => {
  onChange(value)
}
const debouncedOnBlur = _.debounce(onBlur, 1000);

export const NewTextInput = props => {
  let [textValue, setTextValue] = useState(props.value);

  return (
    <TextField
      margin="normal"
      style={{ width: "100%" }}
      variant="outlined"
      {...props}
      value={textValue}
      onBlur={() => onBlur(props.onChange, textValue)}
      onChange={event => {
        setTextValue(event.target.value);
        debouncedOnBlur(props.onChange, event.target.value);
      }}
    />
  )
};
